<template>
  <section class="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
        <DataTable
          :value="measurementUnitLists"
          :paginator="true"
          :rows="10"
          class="p-datatable-responsive p-datatable-gridlines"
          data-key="id"
        >
          <Column header="S.N">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column header="Name" field="name" filterField="name" filterMatchMode="contains"/>
          <Column header="Short Name" field="shortName" filterField="shortName" filterMatchMode="contains"/>
          <Column header="Description Name" field="description" filterField="description" filterMatchMode="contains"/>
          <Column header="Action">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                      @click="editMeasurementUnit(slotProps.data)"/>
              <Button class="p-button-raised p-button-danger" @click="openDialog(slotProps.data.id)"
                      icon="pi pi-trash"/>
            </template>
          </Column>
        </DataTable>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteMeasurement"/>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import Button from 'primevue/button'

export default {
  name: 'measurementUnitList',
  data() {
    return {
      dialogShow: false,
      unitId: ''
    }
  },
  computed: {
    measurementUnitLists() {
      return this.$store.state.itemgroup.measurementUnitLists
    }
  },
  mounted() {
    this.measurementUnitList()
  },
  methods: {
    async measurementUnitList() {
      await this.$store.dispatch('loadMeasurementList')
    },
    async deleteMeasurement(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = false
        return
      }
      let deleteRe = {
        measurementUnitId: this.unitId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteMeasurement', deleteRe)
      if (resp.data.status === 'Success') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editMeasurementUnit(data) {
      this.$emit('edit-account', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.unitId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// measurementUnitList.vue?62bbbf2e